import React from "react";
import { Badge } from "../ui/badge";

export function StatusBadge({ label, variant, className, ...props }) {
  return (
    <Badge
      variant={variant}
      dot
      className={className}
      data-testid={`status-badge-${String(label).toLowerCase().replace(/\s+/g, "-")}`}
      {...props}
    >
      {label}
    </Badge>
  );
}
